const routes = [
    {
        path: '/',
        component: () => import('../components/Home'),
        name: 'home',
        meta: {
            title: 'Главная',
            public: true,
            auth: false
        },
    },
    {
        path: '/login',
        component: () => import('../pages/Login'),
        name: 'login',
        meta: {title: 'Авторизация', public: true}
    },
    {
        path: '/register',
        component: () => import('../pages/Register.vue'),
        name: 'Register',
        meta: {title: 'Регистрация', public: true}
    },
    {
        path: '/user',
        component: () => import('../components/user/'),
        meta: {
            title: 'Пользователь',
            auth: true
        }
    },
    {
        path: '/report/logs',
        component: () => import('../components/report/log'),
        meta: {
            title: 'Рассылки / Логи рассылок',
            gateName: 'report_logs'
        }
    },
    {
        path: '/receipt-email/logs',
        component: () => import('../components/report/receiptEmailLogs'),
        meta: {
            title: 'Рассылки / Логи рассылок квитанций',
            gateName: 'receipts_email_logs'
        }
    },
    {
        path: '/receipt-email/users',
        component: () => import('../components/report/receiptEmailUsers'),
        meta: {
            title: 'Рассылки / Логи рассылок (пользователи)',
            gateName: 'receipts_email_users'
        }
    },
    {
        path: '/report',
        component: () => import('../components/report'),
        name: 'report',
        meta: {
            title: 'Рассылки / Отчёты',
            gateName: 'report'
        }
    },

    {
        path: '/import-billing/sber',
        component: () => import('../pages/Sber'),
        name: 'import-billing-sber',
        meta: {
            title: 'Импорт из СБЕР',
            gateName: 'import-billing-sber'
        }
    },
    {
        path: '/sber/resstrs',
        component: () => import('../pages/SberResstrs'),
        name: 'sber-resstrs',
        meta: {
            title: 'Сверка ресстров Сбера',
            gateName: 'sber-resstrs'
        }
    },
    {
        path: '/sber/upload',
        component: () => import('../pages/SberResstrsUpload'),
        name: 'sber-resstrs-logs',
        meta: {
            title: 'Загрузка реестров',
            gateName: 'sber-resstrs-logs'
        }
    },
    {
        path: '/import-billing/gilservice',
        component: () => import('../components/import-billing/gilservice'),
        name: 'import-billing-gilservice',
        meta: {
            title: 'Импорт из жилсервиса',
            gateName: 'import-billing-gilservice'
        }
    },
    {
        path: '/forwarding',
        component: () => import('../components/forwarding'),
        name: 'forwarding-service',
        meta: {
            title: 'Перенаправления',
            gateName: 'forwarding'
        }
    },
    {
        path: '/generate-zip',
        component: () => import('../pages/generate-zip/GenerateZip'),
        name: 'generate-zip',
        meta: {
            title: 'ZIP',
            gateName: 'generate-zip'
        }
    },
    {
        path: '/ipu',
        component: () => import('../components/ipu'),
        name: 'ipu',
        meta: {
            title: 'ИПУ',
            gateName: 'ipu'
        }
    },
    {
        path: '/properties',
        component: () => import('../pages/Properties'),
        name: 'properties',
        meta: {
            title: 'Настройки',
            gateName: 'properties'
        }
    },
    {
        path: '/waviot',
        component: () => import('../pages/Waviot'),
        name: 'waviot',
        meta: {
            title: 'Импорт из Waviot',
            gateName: 'waviot'
        }
    },
    {
        path: '/format_table',
        component: () => import('../pages/SampleFile.vue'),
        name: 'format_table',
        meta: {
            title: 'Просмотр шаблонов таблиц',
            gateName: 'format_table'
        }
    },
    {
        path: '/invoices',
        component: () => import('../pages/Invoices'),
        name: 'invoices',
        meta: {
            title: 'Работа с квитанциями',
            gateName: 'invoices'
        }
    },
    {
        path: '/invoices-history',
        component: () => import('../pages/InvoicesHistory'),
        name: 'invoices-history',
        meta: {
            title: 'История квитанций',
            gateName: 'invoices-history'
        }
    },
    {
        path: '/add_credits',
        component: () => import('../components/credits/AddCredits.vue'),
        name: 'add_credits',
        meta: {
            title: 'Добавление прав',
            gateName: 'credits',
        }
    },
    {
        path: '*',
        name: '404',
        component: () => import('../pages/404')
    },
    {
        path: '/ErrorForbiden',
        name: 'ErrorForbiden',
        component: () => import('../pages/ErrorForbiden.vue'),
        meta: {
            title: '403 Forbidden',
            public: true,
        }
    },
    {
        path: '/reset-password/:token',
        name: 'ResetPassword',
        component: () => import('../pages/ResetPassword.vue'),
        meta: {
            title: 'Восстановление пароля(1)',
            public: true,
        }
    },
    {
        path: '/forgot-password/',
        name: 'ForgotPassword',
        component: () => import('../pages/ForgotPassword.vue'),
        meta: {
            title: 'Восстановление пароля(2)',
            public: true,
        }
    },
    {
        path: '/import-room/suzhf',
        component: () => import('../components/import-room/import_room-suzhf.vue'),
        name: 'room-suzhf',
        meta: {
            title: 'Импорт помещений в СУЖФ',
            gateName: 'suzhf',
        }
    },
    {
        path: '/upload/gis/logs',
        component: () => import('../pages/UploadGisLogs.vue'),
        name: 'upload-gis-logs',
        meta: {
            title: 'Логи выгрузки в Трансфер',
            gateName: 'upload-gis-logs'
        }
    },
    // {
    //     path: '/import-billing/charges',
    //     component: () => import('../pages/billing/import/charges'),
    //     name: 'import-billing-charges',
    //     meta: {title: 'Импорт начислений',requiresAuth:true}
    // },
    // {
    //     path: '/import-billing/logs',
    //     component: () => import('../components/import-billing/logs'),
    //     name: 'import-billing-logs',
    //     meta: {title: 'Логи по импорту в биллинг',requiresAuth:true}
    // },
    // {
    //     path: '/gymnasium',
    //     component: () => import('../pages/Gymnasium'),
    //     name: 'gymnasium',
    //     meta: {title: 'Рассылки / Гимназия Томь'}
    // },
    // {
    //     path: '/import-billing/ufps',
    //     component: () => import('../components/ufps'),
    //     name: 'ufps',
    //     meta: {title: 'Импорт из УФПС',requiresAuth:true}
    // },
    // {
    //     path: '/props',
    //     component: () => import('../components/props'),
    //     name: 'props',
    //     meta: {title: 'Настройки',requiresAuth:true}
    // },
    // {
    //     path: '/rights',
    //     component: () => import('../components/rights'),
    //     name: 'rights',
    //     meta: {title: 'Права',requiresAuth:true}
    // },
    // {
    //     path: '/transport/ikom',
    //     component: () => import('../components/transport/ikom/non-cash'),
    //     name: 'transport_ikom',
    //     meta: {
    //         title: 'Транспорт / Айком',
    //
    //         gateName: 'credits'
    //     }
    // },
    // {
    //     path: '/transport/ikom-ttu',
    //     component: () => import('../components/transport/ikom/espb'),
    //     name: 'transport_ikom-ttu',
    //     meta: {
    //         title: 'Транспорт / Айком-ТТУ',
    //
    //         gateName: 'credits'
    //     }
    // },
    // {
    //     path: '/transport/sber',
    //     component: () => import('../components/transport/sber'),
    //     name: 'transport_sber',
    //     meta: {
    //         title: 'Транспорт / Сбер',
    //
    //         gateName: 'credits'
    //     }
    // },
    // {
    //     path: '/transport/logs',
    //     component: () => import('../components/transport/log'),
    //     name: 'transport.log',
    //     meta: {
    //         title: 'Транспорт / Логи',
    //
    //     }
    // },
]



export default routes
